@use '@/styles/tokens' as *;

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.heading {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: $color-neutral-950;
}

.tiers {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.tier {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.range {
  display: inline-flex;
  align-items: center;
  gap: 6px; // Figma dimensions/spacing/1.5 — no matching --space token
}

.rangeIcon {
  flex: 0 0 auto;
  color: $color-neutral-800;
}

.rangeNum,
.amount {
  font-size: 15px;
  font-weight: 500;
  color: $color-neutral-800;
}

.value {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
}

/* "units" and "/unit" suffixes: lighter + more muted than the number (Figma Geist Light 13/#555). */
.unit {
  font-size: 13px;
  font-weight: 300;
  color: $color-neutral-700;
}
